var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditLatlng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4339_1174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33317 1.33333H3.99984C3.2665 1.33333 2.6665 1.93333 2.6665 2.66666V13.3333C2.6665 14.0667 3.25984 14.6667 3.99317 14.6667H11.9998C12.7332 14.6667 13.3332 14.0667 13.3332 13.3333V5.33333L9.33317 1.33333ZM11.9998 13.3333H3.99984V2.66666H8.6665V6H11.9998V13.3333Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01996 7.35333C5.10663 8.26667 5.10663 9.74 6.01996 10.6533C6.76663 11.4 7.88663 11.5267 8.77329 11.0467L10.0266 12.3L10.9666 11.36L9.71329 10.1067C10.1866 9.22 10.0666 8.1 9.31996 7.35333C8.40663 6.44 6.92663 6.44 6.01996 7.35333ZM8.37329 9.70667C7.97996 10.1 7.34663 10.1 6.95996 9.70667C6.56663 9.31334 6.56663 8.68 6.95996 8.29333C7.35329 7.9 7.98663 7.9 8.37329 8.29333C8.76663 8.68667 8.76663 9.31334 8.37329 9.70667Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4339_1174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLatlng);
export default __webpack_public_path__ + "static/media/edit_latlng.0fccb00268a2dc1d701f31625f5355fc.svg";
export { ForwardRef as ReactComponent };